module.exports = __webpack_public_path__ + "71c72cb4052474bce5d5aced2d3a4abe.pdf";